// extracted by mini-css-extract-plugin
export var customPlayButton = "wistiaVideoEmbedCustomPlayButton-module--customPlayButton--c9988";
export var customPlayButtonWrapper = "wistiaVideoEmbedCustomPlayButton-module--customPlayButtonWrapper--ec858";
export var isHidden = "wistiaVideoEmbedCustomPlayButton-module--isHidden--1a494";
export var pulse = "wistiaVideoEmbedCustomPlayButton-module--pulse--ced43";